import CookieService from "./cookie.service";

export const hasAuthenticatedCookie = (): boolean => CookieService.get("is_authenticated") === "1";
